import { AvatarGroup } from '@chakra-ui/react'

import UserQ from '@/queries/UserQ'
import type { Query } from '@/client/query'

import UserAvatar from '@/components/UserAvatar'

const TutorPreview: React.FC<{ tutors: Query[]; numShown?: number }> = ({
  tutors,
  numShown = 3,
}) => (
  <AvatarGroup>
    {tutors.slice(0, numShown).map(tutor => (
      <UserAvatar
        size="md"
        key={tutor(UserQ.id) ?? 0}
        src={tutor(UserQ.avatar_url) ?? ''}
        name={`${tutor(UserQ.display_name)}`}
        progressionLevel={tutor(UserQ.progression_level)}
      />
    ))}
  </AvatarGroup>
)

export default TutorPreview
